module.exports = {
  getUser: function () {
    const user = sessionStorage.getItem('user');
    if (user === 'undefined' || !user) {
      return null;
    } else {
      return JSON.parse(user);
    }
  },

  getToken: function () {
    return sessionStorage.getItem('token');
  },

  
  getRefreshToken: function () {
    return sessionStorage.getItem('refreshtoken');
  },

  setUserSession: function (token, refreshtoken, user) {
    sessionStorage.setItem('user', user);
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('refreshtoken', refreshtoken);
  },

  resetUserSession: function () {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('refreshtoken');

  },

  setLocaleLanguage: function(locale){
    localStorage.setItem('laguagePrefered',locale);    
  },

  getLocaleLanguage: function(){
    if((localStorage.getItem('laguagePrefered') === null || localStorage.getItem('laguagePrefered') === "")){
      return 'en'
    }
    else{
      return localStorage.getItem('laguagePrefered')
    }
  }

  
}